"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.save_configuration = void 0;
var api_1 = require("../../api");
var save_configuration = function (request) {
    return (0, api_1.apiPost)({
        endpoint: "v3/configuration/save",
        // data: formData,
        data: request,
    });
};
exports.save_configuration = save_configuration;
